import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateNotificationsApi } from '../../../redux/Reducers/commonApis';
import { toast } from 'react-hot-toast';
import Loader from '../../../components/Loader';
import { getProfileDataApi } from '../../../redux/Reducers/ProfileReducer';

export default function OrgNotifications({ accountType }) {
  const dispatch = useDispatch();
  const { profileData } = useSelector((state) => state.profile);
  const [intitalRender, setIntitalRender] = useState(true);
  const [loading, setLoading] = useState(false);
  const [notificationData, setNotificationData] = useState({
    email: [
      {
        name: 'New Orders',
        data: [
          {
            id: 'new_order_email',
            type: 'Admin',
            active: profileData?.new_order_email_notification || false,
          },
          {
            id: 'member_new_order_email',
            type: 'Member',
            active: profileData?.members?.[0]?.new_order_email_notification || false,
          },
        ],
      },
      {
        name: 'Pickup Reminder',
        data: [
          {
            id: 'pickup_reminder_email',
            type: 'Admin',
            active: profileData?.pickup_reminder_email_notification || false,
          },
          {
            id: 'member_pickup_reminder_email',
            type: 'Member',
            active: profileData?.members?.[0]?.pickup_reminder_email_notification || false,
          },
        ],
      },
      {
        name: 'Delivered Orders',
        data: [
          {
            id: 'delivered_orders_email',
            type: 'Admin',
            active: profileData?.delivered_orders_email_notification || false,
          },
          {
            id: 'member_delivered_orders_email',
            type: 'Member',
            active: profileData?.members?.[0]?.delivered_orders_email_notification || false,
          },
        ],
      },
      {
        name: 'Promotions & Marketing',
        data: [
          {
            id: 'promotions_email_opt_in',
            type: 'Admin',
            active: profileData?.promotions_email_opt_in || false,
          },
          {
            id: 'promotions_email_opt_in_members',
            type: 'Member',
            active: profileData?.promotions_email_opt_in_members || false,
          },
        ],
      },
    ],
    // text: [
    //   {
    //     name: 'Promotions & Marketing',
    //     data: [
    //       {
    //         id: 'marketing_sms_opt_in',
    //         type: 'Admin',
    //         active: profileData?.marketing_sms_opt_in || false,
    //       },
    //       {
    //         id: 'marketing_sms_opt_in_members',
    //         type: 'Member',
    //         active: profileData?.marketing_sms_opt_in_members || false,
    //       },
    //     ],
    //   },
    // ],
  });

  const onEmailSwitchChange = (name, id, status) => {
    setIntitalRender(false);
    setNotificationData((prev) => {
      return {
        ...prev,
        email: prev?.email?.map((item) => {
          if (item?.name === name) {
            return {
              ...item,
              data: item?.data?.map((elm) => {
                if (elm?.id === id) {
                  return {
                    ...elm,
                    active: !status,
                  };
                }
                return elm;
              }),
            };
          }
          return item;
        }),
      };
    });
  };
  const onTextSwitchChange = (name, id, status) => {
    if (accountType == 'ORGANIZATION_MEMBER') {
      toast.error('To make changes to your notification settings please contact the administrator of your account.');
      return;
    }
    setIntitalRender(false);
    setNotificationData((prev) => {
      return {
        ...prev,
        text: prev?.text?.map((item) => {
          if (item?.name === name) {
            return {
              ...item,
              data: item?.data?.map((elm) => {
                if (elm?.id === id) {
                  return {
                    ...elm,
                    active: !status,
                  };
                }
                return elm;
              }),
            };
          }
          return item;
        }),
      };
    });
  };
  useEffect(() => {
    !intitalRender && updateNotificationsFn();
  }, [notificationData]);

  const updateNotificationsFn = () => {
    if (accountType == 'ORGANIZATION_MEMBER') {
      toast.error('To make changes to your notification settings please contact the administrator of your account.');
      return;
    }
    setLoading(true);
    const payload = {};
    notificationData?.email?.map((item) => {
      item?.data?.map((elm) => {
        payload[elm?.id] = elm?.active;
      });
    });
    notificationData?.text?.map((item) => {
      item?.data?.map((elm) => {
        payload[elm?.id] = elm?.active;
      });
    });

    const create = updateNotificationsApi(payload);
    create?.then((res) => {
      if (res?.status === 200 || res?.status === 201 || res?.status === 204) {
        setLoading(false);
        toast.success('Successfully updated!');
        dispatch(getProfileDataApi());
      } else {
        setLoading(false);
        toast.error(res?.message || 'Something went wrong');
      }
    });
  };

  return (
    <>
      <>
        <div className=''>
          <div className='z-0 rounded-lg bg-white sm:mb-6'>
            <header className=' items-center border-b border-gray-100 p-6'>
              <h5 className='go-textnormal-18 my-1 flex-1'>Email Notifications</h5>
            </header>
            {loading ? (
              <Loader text='processing...' classes='h-60' />
            ) : (
              <div className='border-b border-gray-100 p-6'>
                <table className='w-full table-auto'>
                  <thead>
                    <tr>
                      <th className='go-textblack-15'></th>
                      <th className='go-textblack-15'>Admin</th>
                      <th className='go-textblack-15'>Member</th>
                    </tr>
                  </thead>
                  <tbody>
                    {notificationData?.email?.map((item, index) => (
                      <tr key={index}>
                        <td className='go-textblack-15 py-2'>{item.name}</td>
                        {item?.data?.map((elm, idx) => (
                          <td className='go-textblack-15 table-cell justify-items-center py-2 ' key={idx}>
                            <div className={'form-switch '}>
                              <input
                                type='checkbox'
                                id={elm?.id}
                                className='sr-only'
                                checked={elm.active}
                                onChange={(e) => onEmailSwitchChange(item.name, elm.id, elm.active)}
                              />
                              <label className='bg-slate-400' htmlFor={elm?.id}>
                                <span className='bg-white shadow-sm' aria-hidden='true'></span>
                                <span className='sr-only'>Switch label</span>
                              </label>
                            </div>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
        {/* <div className=''>
          <div className='z-0 rounded-lg bg-white '>
            <header className=' items-center border-b border-gray-100 p-6'>
              <h5 className='go-textnormal-18 my-1 flex-1'>Text Notifications</h5>
            </header>
            {loading ? (
              <Loader text='processing...' classes='h-60' />
            ) : (
              <div className='border-b border-gray-100 p-6'>
                <table className='w-full table-auto'>
                  <thead>
                    <tr>
                      <th className='go-textblack-15'></th>
                      <th className='go-textblack-15'>Admin</th>
                      <th className='go-textblack-15'>Member</th>
                    </tr>
                  </thead>
                  <tbody>
                    {notificationData?.text?.map((item, index) => (
                      <tr key={index}>
                        <td className='go-textblack-15 py-2'>{item.name}</td>
                        {item?.data?.map((elm, idx) => (
                          <td className='go-textblack-15 table-cell justify-items-center py-2 ' key={idx}>
                            <div className={'form-switch '}>
                              <input
                                type='checkbox'
                                id={elm?.id}
                                className='sr-only'
                                checked={elm.active}
                                onChange={(e) => onTextSwitchChange(item.name, elm.id, elm.active)}
                              />
                              <label className='bg-slate-400' htmlFor={elm?.id}>
                                <span className='bg-white shadow-sm' aria-hidden='true'></span>
                                <span className='sr-only'>Switch label</span>
                              </label>
                            </div>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div> */}
      </>
    </>
  );
}
